export var ServerGameSessionEvent;
(function (ServerGameSessionEvent) {
    ServerGameSessionEvent["SESSION_HEARTBEAT"] = "session:heartbeat";
    ServerGameSessionEvent["SESSION_UPDATED"] = "session:updated";
    ServerGameSessionEvent["SESSION_INTERACTION"] = "session:interaction";
    ServerGameSessionEvent["USER_JOINED"] = "user:joined";
    ServerGameSessionEvent["USER_LEFT"] = "user:left";
    ServerGameSessionEvent["USER_VOTED"] = "user:voted";
    ServerGameSessionEvent["USER_ROLE_UPDATED"] = "user:roleUpdated";
    ServerGameSessionEvent["ROUND_CLOSED"] = "round:closed";
    ServerGameSessionEvent["ROUND_FINISHED"] = "round:finished";
    ServerGameSessionEvent["ROUND_REPLAY"] = "round:replay";
})(ServerGameSessionEvent || (ServerGameSessionEvent = {}));
//# sourceMappingURL=server.js.map